
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TeamModel } from './Identity.Api.Models.Team';
import { UserModel } from './Identity.Api.Models.User';
import { Model, ModelProperty } from 'models/Model';


export class UserTeamModel extends Model<UserTeamModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'userTeam.property.id', isHidden: true },
		{ name: 'created', type: 'Date', languageString: 'userTeam.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'userTeam.property.deleted', isHidden: true },
		{ name: 'userId', type: 'guid', languageString: 'userTeam.property.userId' },
		{ name: 'teamId', type: 'guid', languageString: 'userTeam.property.teamId' },
		{ name: 'team', type: 'TeamModel', languageString: 'userTeam.property.team', isHidden: true, isObject: true, new: () => { return new TeamModel }, properties: () => { return TeamModel.classProperties } },
		{ name: 'user', type: 'UserModel', languageString: 'userTeam.property.user', isHidden: true, isObject: true, new: () => { return new UserModel }, properties: () => { return UserModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public created?: Date;
	public deleted?: Date;
	public userId?: string;
	public teamId?: string;
	public team?: TeamModel;
	public user?: UserModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.created = undefined;
		this.deleted = undefined;
		this.userId = undefined;
		this.teamId = undefined;
		this.team = undefined;
		this.user = undefined;
		
	}
	getProperties(){
		return UserTeamModel.classProperties;
	}
}

